export enum ESharingState {
    PRIVATE,
    ACCOUNT,
    SUBSET_OF_USERS,
}

export interface INotification {
    shouldNotify: boolean;
    notificationContent?: string;
}

export interface ISharing {
    sharingState: ESharingState;
    notification: INotification;
    sharedWithUsers: Array<number>;
}

export interface IHeaderText {
    title: string;
    subtitle: string;
}

interface ISharingStateTextBase {
    title: string;
    subtitle: string;
}

export type IPrivateText = ISharingStateTextBase;
export type IAccountText = ISharingStateTextBase;

export interface ISubsetOfUsersText extends ISharingStateTextBase {
    notificationDefaultContent: string;
}

export interface ISharingStateContainerText {
    [ESharingState.PRIVATE]: IPrivateText;
    [ESharingState.ACCOUNT]: IAccountText;
    [ESharingState.SUBSET_OF_USERS]: ISubsetOfUsersText;
}

export interface IModalText {
    footer?: {
        shareButton: string;
    };
    header: IHeaderText;
    sharingStateContainer: ISharingStateContainerText;
    disabledStatesBannerKey?: string;
    disabledStatesBannerButtonText?: string;
}

export type IOnSubmit = (sharing: ISharing) => Promise<unknown> | void;
